import type { CheckboxesConfig } from 'components/ui/page-header-with-filters';

const options: CheckboxesConfig['options'] = [
  { value: 'aguardando', label: 'Aguardando' },
  { value: 'iniciado', label: 'Iniciado' },
  { value: 'chegada', label: 'Chegada' },
  { value: 'liberado', label: 'Liberado' },
  { value: 'cancelado', label: 'Cancelado' },
  { value: 'noShow', label: 'No show' },
];
const checkboxesConfig: CheckboxesConfig = {
  options,
  defaultSelected: options.map((option) => option.value),
};

export const usePageHeaderConfig = () => {
  return { checkboxesConfig };
}